import { onUnmounted, ref, unref } from 'vue-demi';

export default (wrapperRef, speed) => {
    // 移动距离
    let moveX = 0;
    // 实例
    let curAnimationFrame;
    // 是否暂停
    const paused = ref(false);

    const destroyScroll = () => {
        curAnimationFrame && window.cancelAnimationFrame(curAnimationFrame);
    };

    const initScroll = (list) => {
        destroyScroll();
        const $wrapper = unref(wrapperRef);
        const originalList = unref(list);
        const wrapperWidth = $wrapper.offsetWidth;
        let contentWidth;
        const calc = () => {
            contentWidth = [...$wrapper.children]?.reduce((sum, child) => sum + child.offsetWidth, 0);
            // 如果宽度不足，补充数组
            if (contentWidth && contentWidth >> 1 <= wrapperWidth) {
                const childrenWidth = contentWidth;
                while (contentWidth >> 1 <= wrapperWidth) {
                    list.value = list.value.concat(originalList);
                    contentWidth += childrenWidth;
                }
            }
        };
        const run = () => {
            if (!paused.value && $wrapper?.hasChildNodes()) {
                const half = contentWidth >> 1;
                if (moveX < 1 - half) {
                    moveX = 0;
                }
                moveX -= speed / 10;
                $wrapper.style.transform = `translate(${moveX}px)`;
            }
            curAnimationFrame = window.requestAnimationFrame(run);
        };
        // 执行逻辑
        calc();

        //过500ms再执行一次calc，因为有时候页面加载完毕后，子元素的宽度还没有计算出来,500只是一个大概的时间
        setTimeout(() => {
            calc();
        }, 500);

        curAnimationFrame = window.requestAnimationFrame(run);
        $wrapper && ($wrapper.onmouseenter = () => {
            paused.value = true;
        });
        $wrapper && ($wrapper.onmouseleave = () => {
            paused.value = false;
        });
    };

    onUnmounted(destroyScroll);

    return {
        initScroll
    };
};
